<template>
  <b-button
    :variant="buttonProperties.disabled ? 'secondary' : 'primary'"
    class="move-button"
    :class="buttonProperties.loading ? 'button-moving' : null"
    :type="type"
    :disabled="buttonProperties.disabled"
    @click="onClick"
  >
    <div class="d-flex align-items-center">
      <b-spinner class="mr-1 move-spinner" v-if="buttonProperties.loading" />
      <move-icon class="mr-1" v-else />
      <span>{{ buttonProperties.label }}</span>
    </div>
  </b-button>
</template>

<script>
  import { BButton, BSpinner } from 'bootstrap-vue';
  import MoveIcon from '@/@core/components/svg/button/Move.vue';

  import { reactive, getCurrentInstance } from '@vue/composition-api';

  export default {
    components: {
      BButton,
      MoveIcon,
      BSpinner,
    },
    props: {
      btnLabel: { type: String, default: 'Move to' },
      type: { type: String, default: 'button' },
    },

    setup(props) {
      const vm = getCurrentInstance().proxy;
      const buttonProperties = reactive({
        loading: false,
        disabled: false,
        label: props.btnLabel,
      });

      const onClick = () => {
        vm.$emit('onClick', buttonProperties);
      };

      return { buttonProperties, onClick };
    },
  };
</script>

<style scoped>
  .move-button {
    padding: 0.786rem 10px;
  }

  .move-spinner {
    width: 22px;
    height: 22px;
  }

  .button-moving {
    padding: 0.786rem 10px;
  }

  .move-button svg {
    fill: var(--button-primary-font);
  }
</style>
